import { DateContainer } from '@enrollhere/classes';

export const parseDateContainer = (date: Date): DateContainer => {
  return {
    date: date,
    timestamp: date.getTime(),
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};
